// extracted by mini-css-extract-plugin
export var breadcrumbs = "how-to-measure-module--breadcrumbs--uPndK";
export var checklist = "how-to-measure-module--checklist--jXB84";
export var checklistItem = "how-to-measure-module--checklist-item--ACgCi";
export var clothesIntro = "how-to-measure-module--clothes-intro--UbOYs";
export var clothesSection = "how-to-measure-module--clothes-section--OhXV2";
export var clothingCard = "how-to-measure-module--clothing-card--y0OU1";
export var clothingGrid = "how-to-measure-module--clothing-grid--s6uC3";
export var clothingIcon = "how-to-measure-module--clothing-icon--JnFi-";
export var faqAnswer = "how-to-measure-module--faq-answer--yyneP";
export var faqCard = "how-to-measure-module--faq-card--Cv3N7";
export var faqGrid = "how-to-measure-module--faq-grid--IdIpL";
export var faqPlus = "how-to-measure-module--faq-plus--wh2K6";
export var faqTitle = "how-to-measure-module--faq-title--LqNww";
export var hero = "how-to-measure-module--hero--JeIGz";
export var heroCopy = "how-to-measure-module--hero-copy--o9+DE";
export var heroLead = "how-to-measure-module--hero-lead--rHbRP";
export var heroTip = "how-to-measure-module--hero-tip--DfGtH";
export var heroTipIcon = "how-to-measure-module--hero-tip-icon--3oNXX";
export var heroTips = "how-to-measure-module--hero-tips--NXPiB";
export var heroTitle = "how-to-measure-module--hero-title--0686n";
export var heroVisual = "how-to-measure-module--hero-visual--bVksC";
export var measurePage = "how-to-measure-module--measure-page--R-uPt";
export var measurementCard = "how-to-measure-module--measurement-card--SoIOj";
export var measurementIcon = "how-to-measure-module--measurement-icon--PBZNi";
export var measurementNumber = "how-to-measure-module--measurement-number--MGxUE";
export var measurementText = "how-to-measure-module--measurement-text--Wd4BG";
export var measurementTitle = "how-to-measure-module--measurement-title--jU1Fw";
export var measurementsGrid = "how-to-measure-module--measurements-grid--ZdONV";
export var mistakeCard = "how-to-measure-module--mistake-card--5IdiL";
export var mistakeIcon = "how-to-measure-module--mistake-icon--80Fnc";
export var mistakesGrid = "how-to-measure-module--mistakes-grid--hY-1C";
export var mistakesInner = "how-to-measure-module--mistakes-inner--bbuGk";
export var mistakesIntro = "how-to-measure-module--mistakes-intro--02Zya";
export var mistakesSection = "how-to-measure-module--mistakes-section--lBD8-";
export var pageShell = "how-to-measure-module--page-shell--7LPAS";
export var reminder = "how-to-measure-module--reminder--21IzM";
export var reminderAction = "how-to-measure-module--reminder-action--Tbi77";
export var reminderCopy = "how-to-measure-module--reminder-copy--wlenH";
export var reminderEyebrow = "how-to-measure-module--reminder-eyebrow--syAEY";
export var reminderImage = "how-to-measure-module--reminder-image--ugvT2";
export var section = "how-to-measure-module--section--fj60c";
export var sectionAccent = "how-to-measure-module--section-accent--vMkOh";
export var sectionHeading = "how-to-measure-module--section-heading--iC56I";